// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"64b75a0a","196":"77127869","278":"64b75a0a","421":"64b75a0a","661":"64b75a0a"}[chunkId] + ".chunk.css";
};